import * as React from "react";
import {VeBoxCard} from "../../components/card/VeBoxCard";
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import {Button, Tooltip} from "@vebox/etui-core";
import {Display} from "../../components/Display";
import {VeBoxModal} from "../../components/modal/VeBoxModal";
import {RestDataLoader} from "../../dashboard/widgets/unilever/RestDataLoader";
import {useUserDetails} from "../contexts/UserDetailsContext";
import {Loader} from "../../components/Utils/loader/Loader";
import {useNavigate} from "react-router-dom";

declare var AppTranslations: AppTranslations;

interface Messages {
    successMessage: string;
    errorMessage: string;
}

enum Status {
    "error" = "error",
    "success" = "success",
    "processing" = "processing",
    "default" = "default",
}

export const DeleteUser: React.FC<{}> = () => {

    const navigate = useNavigate();
    const [currentUserFromContext] = useUserDetails();
    const [showConfirmationModal, setShowConfirmationModal] = React.useState(false);
    const [messages, setMessages] = React.useState<Messages>();
    const [state, setState] = React.useState<Status>(Status.default);
    const translations = AppTranslations.usersManagement.usersDeleteSection;

    const showConfirmationModalDialog = (show: boolean) => () => {
        if (!show) {
            setState(Status.default);
        }
        setShowConfirmationModal(show)
    };

    const deleteCurrentUser = () => {
        setState(Status.processing);
        deleteUser(currentUserFromContext.guid)
            .then((resp) => {
                setState(Status.success);
                setTimeout(() => {
                    setShowConfirmationModal(false);
                    navigate("..", {replace: true, state: undefined})
                }, 3000);
            })
            .catch((err) => {
                setState(Status.error)
                console.error(err);
            })
    }

    React.useEffect(() => {
        switch (state) {
            case Status.success:
                setMessages({successMessage: translations.successMessage, errorMessage: ""})
                break;
            case Status.error:
                setMessages(
                    {successMessage: "", errorMessage: translations.errorMessage})
                break;
            default:
                setMessages({successMessage: "", errorMessage: ""})
        }
    }, [state])

    return (
        <>
            <Display isVisible={showConfirmationModal}>
                <div className={"cover-content-container"}>
                    <VeBoxModal>
                        <VeBoxModal.Header title={translations.title}/>
                        <VeBoxModal.Body style={{minHeight: "150px", minWidth: "435px"}}>
                            <VeBoxModal.Section>
                                <Display isVisible={state === Status.default || state === Status.processing}>
                                    <p className={"textAlignLeft padding-bottom-10px"}>{translations.deleteUserInfo}</p>
                                    <p className={"textAlignLeft padding-bottom-20px"}>{translations.deleteUserQuestion}</p>
                                </Display>
                                <Display isVisible={state === Status.success}>
                                    <div className={"delete-user-badge success-badge"}>
                                        <span className="material-icons">task_alt</span>
                                        <p className={"text"}>{messages?.successMessage}</p>
                                    </div>
                                </Display>
                                <Display isVisible={state === Status.error}>
                                    <div className={"delete-user-badge error-badge"}>
                                        <span className="material-icons">task_alt</span>
                                        <p className={"text"}>{messages?.errorMessage}</p>
                                    </div>
                                </Display>
                                <Display isVisible={state === Status.processing}>
                                    <Loader relativelyCentered={true}/>
                                </Display>
                            </VeBoxModal.Section>
                        </VeBoxModal.Body>
                        <Display isVisible={state !== Status.processing && state !== Status.success}>
                            <VeBoxModal.StandardActions
                                onSubmit={deleteCurrentUser}
                                submitText={translations.title}
                                onCancel={showConfirmationModalDialog(false)}
                            />
                        </Display>

                    </VeBoxModal>
                </div>
            </Display>
            <VeBoxCard className={"Section"}>
                <VeBoxCard.Header
                    title={translations.title}
                    singleLineTitle={true}
                    back={
                        <Tooltip
                            message={translations.title}
                            placement={"left"}
                        >
                            <Button
                                onClick={showConfirmationModalDialog(true)}
                                variant={"strong"}
                                shape={"circle"}
                                styles={{root: {width: "42px", height: "42px"}}}
                            >
                                <span className="material-icons-outlined">delete</span>
                            </Button>
                        </Tooltip>
                    }
                />
            </VeBoxCard>
        </>
    )
}

function deleteUser(userGuid: string): Promise<any> {
    return new Promise<any>((res, rej) => {
        RestDataLoader.deleteJSON(
            "users/" + userGuid,
            null,
            res,
            rej
        );
    });
}
